export default {"src":"/_next/static/media/no_image.a5f9f018.svg","height":379,"width":379};